<template>
  <div class="stepper">
    <div
      v-for="(step, i) in steps"
      :key="i"
      class="step"
      :class="{
        'step--active': currentStep === i,
        'step--edited': i < currentStep,
        'step--completed': i < currentStep,
        'step--disabled': disabled && i > 0
      }"
    >
      <router-link
        :to="{ path: $route.path, query: { step: i } }"
        :disabled="disabled && i > 0"
        tag="button"
      >
        <div class="step_content">
          <div class="step_icon">
            <v-icon v-if="i < currentStep" color="#ffffff">mdi-check</v-icon>
          </div>
          <div class="step_title">{{ step.title }}</div>
        </div>
        <div v-if="i < steps.length - 1" class="step_progress"></div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    stepsCompletedStatus: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "Stepper";
</style>
